<div *ngIf="isLoaded">
    <lls-datagrid [hidden]="isEditPost" [options]="postsGridOptions" (rowsSelected)="rowsSelected($event)" #postsTable></lls-datagrid>
    <app-edit-post *ngIf="isEditPost"
                   [post]="postInEditMode"
                   [pagePosts]="currentPagePosts()"
                   (onInit)="onFormCreated($event)"
                   (onEditCancel)="onEditCancel()"
                   (onEditSave)="onEditSave()"></app-edit-post>
</div>
<div *ngIf="!isLoaded" class="d-flex justify-content-center spinner">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
